export default class YoutubeFacade {
  constructor() {
    this.facades = document.querySelectorAll('.js-youtube_facade:not(.is-played)');

    if (this.facades.length !== 0) {
      this.init();
    }
  }

  init() {
    this.facades.forEach((facade) => {
      const url = facade.querySelector('.o-bk__youtube_url a')?.href;
      const videoId = this.getVideoId(url);

      if (!this.isValidVideoId(videoId)) {
        return;
      }

      this.setThumbnail(facade, videoId);

      facade.setAttribute('role', 'button');
      facade.setAttribute('tabindex', '0');
      facade.setAttribute('aria-label', '動画を再生');

      facade.addEventListener('click', () => this.play(facade));
      facade.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.play(facade);
        }
      });
    });
  }


  setThumbnail(facade, videoId) {
    // 指定した画質のサムネイルURLをCSS変数にセット
    const apply = (quality) => {
      facade.style.setProperty(
        '--youtube-thumb',
        `url("https://img.youtube.com/vi/${videoId}/${quality}.jpg")`
      );
      facade.classList.add('has-thumbnail');
    };

    const img = new Image();
    
    // 最高画質サムネイルが存在すれば使用し、なければ標準画質に切り替える
    img.onload = () => apply('maxresdefault');
    img.onerror = () => apply('hqdefault');
    img.src = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  }


  play(facade) {
    if (facade.classList.contains('is-played')) {
      return;
    }

    const url = facade.querySelector('.o-bk__youtube_url a')?.href;
    const videoId = this.getVideoId(url);

    if (!this.isValidVideoId(videoId)) {
      return;
    }

    const player = document.createElement('div');
    player.className = 'o-bk__youtube_player';

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    iframe.title = 'YouTube video player';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');

    player.appendChild(iframe);
    facade.appendChild(player);

    facade.classList.add('is-played');
    facade.removeAttribute('role');
    facade.removeAttribute('tabindex');
    facade.removeAttribute('aria-label');
  }


  isValidVideoId(videoId) {
    //サンプル値（'VIDEO_ID'）ではなく、なおかつYouTube動画IDの形式（11文字）になっているかチェック
    return Boolean(videoId) && videoId !== 'VIDEO_ID' && /^[\w-]{11}$/.test(videoId);
  }


  //入力されたURLから動画IDを取り出す
  getVideoId(url) {
    if (!url) {
      return '';
    }
    
    try {
      const parsed = new URL(url);
      // www. を除いたホスト名で判定
      const host = parsed.hostname.replace(/^www\./, '');

      // 短縮URLの場合
      if (host === 'youtu.be') {
        return parsed.pathname.slice(1).split('/')[0];
      }

      // 通常・モバイル版の場合
      if (host === 'youtube.com' || host === 'm.youtube.com') {
        if (parsed.pathname.startsWith('/embed/')) {
          return parsed.pathname.split('/')[2];
        }

        // 視聴URLの場合（v パラメータなしは空文字）
        return parsed.searchParams.get('v') || '';
      }
    } catch (error) {
      return '';
    }

    return '';
  }
}
